<button
  mat-icon-button
  [matMenuTriggerFor]="menu"
  aria-label="User menu"
  matTooltip="Account"
  class="avatar-circle"
>
  <div class="avatar-icon">
    <mat-icon>LG</mat-icon>
  </div>
</button>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="editProfile()">
    <span>Profil</span>
  </button>
  <button mat-menu-item (click)="logout()">
    <span>Abmelden</span>
  </button>
</mat-menu>
